import React, { Component } from 'react';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import { Selection } from '~/GroupProduct';
import { selectCardinalPlural } from '~/libs/Intl';
import ProductGroupAddForm from '~/ProductGroupAddForm';

import styles from './styles.less';

interface Props {
	selection: Selection;
	selectedProductsCount: number;
	onAddProductsToGroup(group: UserProductGroup, selection: Selection): void;
}

export default class GroupPanel extends Component<Props> {
	handleSave = (group: UserProductGroup) => {
		const { onAddProductsToGroup, selection } = this.props;
		onAddProductsToGroup(group, selection);
	};

	render() {
		const { selectedProductsCount } = this.props;

		return (
			<div className={styles.container}>
				<p className={styles.text}>
					Put <strong>{selectedProductsCount}</strong> selected{' '}
					{selectCardinalPlural(selectedProductsCount, ['drug', 'drugs'])}
				</p>
				<ProductGroupAddForm productsCount={selectedProductsCount} onSave={this.handleSave} />
			</div>
		);
	}
}
